function n(r, e) {
  if (!r) return "";
  const t = new URL(r);
  return Object.keys(e).forEach((s) => {
    t.searchParams.set(s, e[s]);
  }), t.toString();
}
export {
  n as setQueryParams
};
